import { GetterTree } from 'vuex';

import { State } from './state';
import { SegNotificacaoModel } from '@/models/message/seg-notificacao.model';

export type Getters = {
  getMessages(state: State): SegNotificacaoModel[];
};

export const getters: GetterTree<State, any> & Getters = {
  getMessages: (state) => state.messages as SegNotificacaoModel[]
};
